import React, { FC } from 'react';
import s from './brandButton.module.scss';
import img1 from './img/img1.png';

type Props = {
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  animateButton?: boolean;
  children?: JSX.Element;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  noShadows?: boolean;
};

export const BrandButton: FC<Props> = props => {
  const { disabled, animateButton, type, children, onClick, noShadows, ...rest } = props;
  return (
    <button
      className={`${s.brandButton} ${animateButton ? s.brandButton__animate : ''} ${noShadows ? s.noShadows : ''}`}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span className={s.brandButtonContent}>{children}</span>
      {rest['data-test'] !== "pay-button" && (
        <img src={img1} alt='image'/>
      )}
    </button>
  );
};